import Vue from 'vue'
import VueGtag from 'vue-gtag'

Vue.use(VueGtag, {
  config: { id: process.env.NODE_ENV === 'development' ? 'G-PGC12ZDCEN' : 'G-CN927GR3HN' }
})
